import React from 'react';
import { Link } from 'react-router-dom';

const Terms: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-slate-900">Terms and Conditions</h1>
        <p className="text-slate-600">Last updated: September 29, 2025</p>
      </div>

      <div className="glass-card space-y-8">
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">1. Overview</h2>
          <p className="text-slate-700 leading-relaxed">
            These Terms and Conditions ("Terms") govern your use of SurveyMyStore ("the Service") 
            provided by AE-Cloudsystem Oy ("we," "us," or "our"). By using SurveyMyStore, you agree 
            to these Terms in their entirety.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">2. License & Usage</h2>
          <div className="space-y-2">
            <p className="text-slate-700 leading-relaxed">
              Subject to these Terms, we grant you a limited, non-exclusive, non-transferable 
              license to use SurveyMyStore in your applications. You agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Use the Service only as permitted by applicable laws</li>
              <li>Maintain the security of your account credentials</li>
              <li>Respect the privacy and rights of end users</li>
              <li>Not modify or create derivative works of the Service</li>
            </ul>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">3. Privacy & Data</h2>
          <p className="text-slate-700 leading-relaxed">
            SurveyMyStore is designed with privacy in mind. We collect only essential data needed 
            for the Service to function. All data collection and processing comply with GDPR 
            and other applicable privacy laws.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">4. Service Level Agreement</h2>
          <p className="text-slate-700 leading-relaxed">
            We strive to maintain 99.9% uptime for the Service. However, we do not guarantee 
            uninterrupted access and may occasionally need to perform maintenance or updates.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">5. Intellectual Property</h2>
          <p className="text-slate-700 leading-relaxed">
            All intellectual property rights in the Service remain the property of 
            AE-Cloudsystem Oy. Nothing in these Terms transfers any rights to you except 
            the limited license described above.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">6. Termination</h2>
          <p className="text-slate-700 leading-relaxed">
            We reserve the right to suspend or terminate your access to the Service if you 
            violate these Terms or use the Service in a manner that could harm us or others.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">7. Contact</h2>
          <p className="text-slate-700 leading-relaxed">
            For questions about these Terms, please contact us at{' '}
            <a href="mailto:legal@aecloudsystem.com" className="text-brand-600 hover:underline">
              legal@aecloudsystem.com
            </a>
          </p>
        </section>
      </div>

      <div className="flex justify-center">
        <Link to="/softwares/surveymystore" className="btn-secondary">
          Back to SurveyMyStore
        </Link>
      </div>
    </div>
  );
};

export default Terms;